import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/common/Button';
import { useHasLogtoRole } from '@/hooks/useHasLogtoRole';
import { rottaGuarda } from '@/lib/qsocials/liveMatch';
import { rottaBackgammonLiveInBuild } from '@/lib/qsocials/rottaGuardaBuild';
import type { LiveMatch } from '@/types/social';

/**
 * «Guarda» — il bottone accanto a «sta giocando» (contratto di fronte QSocials r38). Le regole stanno in
 * `lib/qsocials/liveMatch.ts` (`rottaGuarda`): un `game` che la TMA non conosce, un `matchId` che non e' un UUID
 * di QGammon, una build senza la rotta o un utente non `beta` ⇒ NIENTE bottone (un bottone verso un vicolo cieco
 * non si offre). «Sta giocando» resta: lo mostra chi chiama, non questo componente.
 *
 * Il ruolo si legge qui, e questo componente si monta SOLO quando c'e' un `liveMatch` da mostrare: le righe
 * senza partita non pagano il hook.
 */
export function GuardaLive({ live, className }: { live: LiveMatch; className?: string }) {
  const { t } = useTranslation('general');
  const navigate = useNavigate();
  const beta = useHasLogtoRole('beta');
  const rotta = rottaGuarda(live, { rottaBackgammonLive: rottaBackgammonLiveInBuild(), beta });
  if (!rotta) return null;
  return (
    <Button
      size="sm"
      variant="primary"
      forma="pastiglia"
      className={className}
      data-testid="guarda-live"
      onClick={() => navigate(rotta)}
    >
      {t('social.watch_live', { defaultValue: 'Watch' })}
    </Button>
  );
}
